import React from 'react';

import { sortBy } from 'lodash';
import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxSubAbuse } from '../../../../libs/apps/epxsubabuse';

const EpxSubAbuseGraphs: React.FC<GraphInstanceProps> = (
  props
): JSX.Element => {
  const graph: GraphBlueprint<IEpxSubAbuse> = {
    name: 'FallRisk Graph',
    config: {
      chart: {
        type: null
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: {
        title: {
          text: 'Uses'
        },
        min: 0
      },
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries = {
        type: 'line',
        name: 'Substance Uses',
        connectNulls: true
      };
      const data: GraphPoint[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        let value = null;
        if (session.slipped != null) {
          value = session.slipped ? 1 : 0;
        }
        data.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: value,
          x: i
        });
      }
      series.data = data;
      options.series = [series];
      options.xAxis = {
        ...currentOptions.xAxis
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxSubAbuse>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxSubAbuseGraphs;
